import { render, staticRenderFns } from "./MemberMiniTestViewerComponent.vue?vue&type=template&id=252bf227&scoped=true&"
import script from "./MemberMiniTestViewerComponent.vue?vue&type=script&lang=js&"
export * from "./MemberMiniTestViewerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252bf227",
  null
  
)

export default component.exports